import React, { useState, useEffect } from "react";
import BackButton from "../../common/BackButton";
import { Grid } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getMaterialHelpList } from "../../../api/firestoreData";
import LoaderScreen from "../../common/LoaderScreen/LoaderScreen";
import ScreenAlert from "../../common/ScreenAlert/ScreenAlert";
import classes from "./MaterialHelpList.module.css";
import MaterialHelpEntry from "./MaterialHelpEntry/MaterialHelpEntry";

const categoryEnum = {
  clothing: "Šatstvo",
  food: "Strava",
  cosmetic: "Drogéria",
};

function MaterialHelpListPage() {
  const [data, setData] = useState(null);
  let categories = [];
  useEffect(() => {
    getMaterialHelpList().then((res) => {
      setData(res);
    });
  }, []);
  if (data === undefined) {
    return (
      <ScreenAlert
        severity="error"
        fontSize={50}
        message="Vyskytla sa chyba pri vyhľadaní materiálnych pomocí"
      />
    );
  } else if (data === null) {
    return (
      <>
        <BackButton />
        <LoaderScreen />
      </>
    );
  }
  categories = getCategories(data);
  return (
    <>
      <BackButton />
      <Grid
        className={classes.grid}
        container
        direction={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        spacing={4}
      >
        {categories.map((category) => (
          <Grid item key={category} className={classes.gridItem}>
            <Accordion sx={{ padding: "25px" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ fontSize: "3rem" }} />}
              >
                <Typography sx={{ fontSize: "3rem", fontWeight: 500 }}>
                  {Object.keys(categoryEnum).includes(category)
                    ? categoryEnum[category]
                    : "Ostatné"}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid
                  container
                  direction={"column"}
                  alignItems={"center"}
                  spacing={4}
                >
                  {data
                    .filter(
                      (nonFilteredEntry) =>
                        nonFilteredEntry.category === category
                    )
                    .map((entry) => (
                      <Grid item key={entry.provides} sx={{ width: "96%", mb: "20px" }}>
                        <MaterialHelpEntry entry={entry} />
                      </Grid>
                    ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))}
      </Grid>
      )
    </>
  );
}

export default MaterialHelpListPage;

const getCategories = (data) => [...new Set(data.map((item) => item.category))];
